import { GlFormGroup } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { s__, sprintf } from '~/locale';
import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
export default {
    name: 'FormGroup',
    components: {
        GlFormGroup
    },
    mixins: [
        glSlotsMixin
    ],
    props: {
        field: {
            type: Object,
            required: true
        },
        fieldValue: {
            type: [
                String,
                Number,
                Array
            ],
            required: false,
            default: null
        }
    },
    data () {
        return {
            state: true,
            invalidFeedback: null
        };
    },
    computed: {
        hasLabelDescription () {
            return this.glSlots()['label-description'];
        }
    },
    methods: {
        // eslint-disable-next-line vue/no-unused-properties -- reset() is part of the component's public API, called via $refs by parent forms.
        reset () {
            this.state = true;
            this.invalidFeedback = null;
        },
        validate () {
            const { requiredLabel, maxLength } = this.field.validations;
            if (requiredLabel) {
                this.state = Boolean(this.fieldValue);
                this.invalidFeedback = requiredLabel;
            }
            if (maxLength && this.fieldValue?.length > maxLength) {
                this.state = this.fieldValue?.length <= maxLength;
                this.invalidFeedback = sprintf(s__('AICatalog|Input cannot exceed %{value} characters.'), {
                    value: maxLength
                });
            }
            return this.state;
        },
        onBlur () {
            this.validate();
        }
    }
};
